import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import FormRepository from '../Repositories/FormRepository'


class FormBloc {

    detailChannel = new Subject();
    pdfChannel = new Subject();
    repository = new FormRepository()

    constructor() {
        this.detailChannel.next({status: apiResponse.INITIAL})
        this.pdfChannel.next({status: apiResponse.INITIAL})
    }

    fetchDetail = async (query) => {
        try {
            this.detailChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchDetail(query).then((result) => {
                this.detailChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.detailChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {console.log('rxjs', 'Channel Unsubscribed')}
    }

    fetchPdf = async (query) => {
        try {
            this.pdfChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchPdf(query).then((result) => {
                this.pdfChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.pdfChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {console.log('rxjs', 'Channel Unsubscribed')}
    }
}

export default FormBloc